/**
 * A change made offline that is only a deletion (text removed from a note,
 * a key deleted) adds no new structs, so comparing per-client clocks with
 * the server misses it; the reconnect then never sends it. This compares
 * what each side has deleted instead. Pure (tested).
 */
import * as Y from "yjs";

/** Whether sorted ranges [{clock, len}] cover clock..clock+len. */
function covered(ranges, clock, len) {
  let position = clock;
  const end = clock + len;
  for (const range of ranges) {
    if (range.clock + range.len <= position) continue;
    if (range.clock > position) return false;
    position = range.clock + range.len;
    if (position >= end) return true;
  }
  return position >= end;
}

/**
 * Whether `doc` holds deletions that `serverUpdate` (the server's content,
 * merged) doesn't.
 * @param {Y.Doc} doc
 * @param {Uint8Array} serverUpdate
 */
export function hasUnsentDeletions(doc, serverUpdate) {
  const local = Y.snapshot(doc).ds.clients;
  const server = Y.decodeUpdate(serverUpdate).ds.clients;
  for (const [client, items] of local) {
    const ranges = [...(server.get(client) || [])].sort((a, b) => a.clock - b.clock);
    for (const item of items) {
      if (!covered(ranges, item.clock, item.len)) return true;
    }
  }
  return false;
}
